module.exports = __webpack_public_path__ + "static/media/arrow-left.db996064.svg";